'use client';

import { Dialog as TailwindDialog } from '@material-tailwind/react';
import { usePathname, useRouter } from 'next/navigation';
import { useCmsHashState } from '../../../hooks/useHashState';
import Body from './Body';
import Footer from './Footer';
import Header from './Header';
import { ExclusiveRewardsModalProps } from './types';

export const ExclusiveRewardsModal: React.FC<ExclusiveRewardsModalProps> = ({
  isOpen,
  onClose,
  product,
  carInsuranceQuotes,
  productWithLivePrice,
  metadata,
  onCreateLead,
  pushDataLayer,
}) => {
  const pathname = usePathname();
  const router = useRouter();

  const [params, setHashParams] = useCmsHashState<{
    exclusiveRewardsProductUid: string;
  }>({
    exclusiveRewardsProductUid: 'string',
  });

  const isHashExists = Boolean(params.exclusiveRewardsProductUid);

  const handleBack = () => {
    if (window.history.length <= 2) {
      // deep link handler
      window.location.hash = '';
      router.replace(pathname || '/', { scroll: false });
      // setIsHashExists(false);
      setHashParams({ exclusiveRewardsProductUid: undefined });
      onClose();
    } else {
      router.back();
    }
  };

  const welcomeOffers = product?.welcome_offers ?? [];
  const exclusiveOffers = [
    ...(product?.exclusive_offers ?? []),
    ...(product?.bundle_exclusive_offers ?? []),
  ];
  const offers = [...exclusiveOffers, ...welcomeOffers];

  const singleGiftOffers = offers.filter(
    (item) => (item.list_of_gifts?.length ?? 0) === 1,
  );
  const multipleGiftsOffers = offers.filter(
    (item) => (item.list_of_gifts?.length ?? 0) > 1,
  );
  const isGiftOffersAvailable =
    Boolean(singleGiftOffers.length) || Boolean(multipleGiftsOffers.length);
  const carInsuranceSection = metadata?.product_card?.find(
    (p) => p.productBlock?.product?.uid === product?.uid,
  )?.productBlock?.car_insurance;

  return (
    <TailwindDialog
      size="xxl"
      className="size-full bg-white overflow-x-hidden"
      open={isOpen && isHashExists}
      handler={(isOpen) => {
        if (!isOpen) {
          handleBack();
        }
      }}
    >
      <Header
        isGiftOffersAvailable={isGiftOffersAvailable}
        brandLogoUrl="https://mhgprod.blob.core.windows.net/singsaver/strapi-uploads/933_singsaver_white_9d76b81661.svg"
        handleBack={handleBack}
      />
      <Body
        product={product}
        singleGiftOffers={singleGiftOffers}
        multipleGiftsOffers={multipleGiftsOffers}
        isGiftOffersAvailable={isGiftOffersAvailable}
        carInsuranceQuotes={carInsuranceQuotes}
        productWithLivePrice={productWithLivePrice}
        carInsuranceSection={carInsuranceSection}
      />
      <Footer
        product={product}
        onClose={handleBack}
        onCreateLead={onCreateLead}
        pushDataLayer={pushDataLayer}
      />
    </TailwindDialog>
  );
};
